import { get, del, post, put } from '../request';

export async function fetchCategories(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/categorylist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addCategory(
  { equityfinderService },
  authenticationToken,
  formData,
) {
  const url = `${equityfinderService}/equityfinder/categorylist`;
  const { body } = await post(authenticationToken, url, formData);
  return body;
}

export async function updateCategory(
  { equityfinderService },
  authenticationToken,
  { formData, categoryId },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}`;
  const { body } = await put(authenticationToken, url, formData);
  return body;
}

export async function deleteCategory(
  { equityfinderService },
  authenticationToken,
  { categoryId },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchConfiguration(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/category/config`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRegressionRuleSets(
  { equityfinderService },
  authenticationToken,
  { categoryId },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/categoryregressionpoolrulesetlist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addRegressionRuleSet(
  { equityfinderService },
  authenticationToken,
  { categoryId, data },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/categoryregressionpoolrulesetlist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function editRegressionRuleSet(
  { equityfinderService },
  authenticationToken,
  { ruleSetId, data },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/${ruleSetId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteRegressionRuleSet(
  { equityfinderService },
  authenticationToken,
  { ruleSetId },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/${ruleSetId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchRegressionRuleSet(
  { equityfinderService },
  authenticationToken,
  { ruleSetId },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/${ruleSetId}/rulelist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addRegressionRule(
  { equityfinderService },
  authenticationToken,
  { ruleSetId, data },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/${ruleSetId}/rulelist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function editRegressionRule(
  { equityfinderService },
  authenticationToken,
  { ruleId, data },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/rule/${ruleId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteRegressionRule(
  { equityfinderService },
  authenticationToken,
  { ruleId },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/rule/${ruleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setOrderRegressionRuleSets(
  { equityfinderService },
  authenticationToken,
  { categoryId, ruleSetList },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/categoryregressionpoolrulesetlist/setorder`;
  const { body } = await post(authenticationToken, url, {
    rulesetList: ruleSetList,
  });
  return body;
}

export async function copyRegressionRuleSet(
  { equityfinderService },
  authenticationToken,
  { ruleSetId },
) {
  const url = `${equityfinderService}/equityfinder/categoryregressionpoolruleset/${ruleSetId}/copy  `;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchCompSelectionRules(
  { equityfinderService },
  authenticationToken,
  { categoryId },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/categorycompscoringruleslist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addCompSelectionRules(
  { equityfinderService },
  authenticationToken,
  { categoryId, data },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/categorycompscoringruleslist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function editCompSelectionRules(
  { equityfinderService },
  authenticationToken,
  { ruleId, data },
) {
  const url = `${equityfinderService}/equityfinder/categorycompscoringrules/${ruleId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteCompSelectionRules(
  { equityfinderService },
  authenticationToken,
  { ruleId },
) {
  const url = `${equityfinderService}/equityfinder/categorycompscoringrules/${ruleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchGlobalScoringRules(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/globalcompscoringruleslist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGlobalScoringRule(
  { equityfinderService },
  authenticationToken,
  { ruleId },
) {
  const url = `${equityfinderService}/equityfinder/globalcompscoringrules/${ruleId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addGlobalScoringRules(
  { equityfinderService },
  authenticationToken,
  data,
) {
  const url = `${equityfinderService}/equityfinder/globalcompscoringruleslist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function editGlobalScoringRules(
  { equityfinderService },
  authenticationToken,
  { ruleId, data },
) {
  const url = `${equityfinderService}/equityfinder/globalcompscoringrules/${ruleId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteGlobalScoringRules(
  { equityfinderService },
  authenticationToken,
  { ruleId },
) {
  const url = `${equityfinderService}/equityfinder/globalcompscoringrules/${ruleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchCompGridConfiguration(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/configurationlist/compgrid`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCompGridOption(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/configuration/compgrid`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function saveCompGridConfiguration(
  { equityfinderService },
  authenticationToken,
  { configurationId, data },
) {
  const url = `${equityfinderService}/equityfinder/configuration/${configurationId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchSystemConfiguration(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/configuration/systemsettings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function saveSystemConfiguration(
  { equityfinderService },
  authenticationToken,
  { configurationId, data },
) {
  const url = `${equityfinderService}/equityfinder/configuration/${configurationId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchBaseUnitList(
  { equityfinderService },
  authenticationToken,
  { pYear },
) {
  const url = `${equityfinderService}/equityfinder/baseunitpricelist?pYear=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addBaseUnit(
  { equityfinderService },
  authenticationToken,
  { data },
) {
  const url = `${equityfinderService}/equityfinder/baseunitpricelist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchBaseUnit(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/baseunitprice/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function editBaseUnit(
  { equityfinderService },
  authenticationToken,
  { id, data },
) {
  const url = `${equityfinderService}/equityfinder/baseunitprice/${id}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteBaseUnit(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/baseunitprice/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchProdigyScoreList(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/configuration/prodigyscore`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function editProdigyScore(
  { equityfinderService },
  authenticationToken,
  { id, data },
) {
  const url = `${equityfinderService}/equityfinder/configuration/${id}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchTemplates(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/templatelist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTemplate(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/template/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteTemplate(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/template/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createTemplate(
  { equityfinderService },
  authenticationToken,
  data,
) {
  const url = `${equityfinderService}/equityfinder/templatelist`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateTemplate(
  { equityfinderService },
  authenticationToken,
  { id, data },
) {
  const url = `${equityfinderService}/equityfinder/template/${id}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function setDefaultTemplate(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/template/${id}/setdefault`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function addCategoryTemplate(
  { equityfinderService },
  authenticationToken,
  { categoryId, templateId },
) {
  const url = `${equityfinderService}/equityfinder/category/${categoryId}/settemplate`;
  const { body } = await put(authenticationToken, url, {
    templateID: templateId,
  });
  return body;
}

export async function removeCategoryTemplate(
  { equityfinderService },
  authenticationToken,
  { id },
) {
  const url = `${equityfinderService}/equityfinder/category/${id}/removetemplate`;
  const { body } = await put(authenticationToken, url);
  return body;
}
